<template>
  <div class="container">

    <div id="cover">
      <img ref="ahImg" src="../assets/lights.jpg" id="ahImg" />
    </div>

    <div class="profileCard" id="pTop">
      
      <div class="img" ref="meshMe">
        <img src="../assets/profile.jpg" alt="photo" id="photo" />
        <div class="head">
          <h1>Félix Natanael Abad</h1>
          <p class="mainskill" :style="{ marginBottom:'5px' }">Systems and Computing Engineer.</p>
          <p class="mainskill">Web Developer.</p>

          <div class="coreTech">
            <!-- <span class="skills">HTML, CSS, JavaScript (Vanilla, VueJS and NodeJS), MongoDB, .NET Framework/.NET Core (C#), SQL Server</span> -->
            
            <div>
              <img src="/img/skills/JavaScript.png" alt="js">
              <p>JavaScript (Vanilla)</p>
            </div>

            <div>
              <img src="/img/skills/node.png" alt="nodejs">
              <p>NodeJS</p>
            </div>

            <div>
              <img src="/img/skills/vue.png" alt="vuejs">
              <p>VueJS</p>
            </div>

            <div>
              <img src="/img/skills/mongodb.png" alt="mongodb">
              <p>MongoDB</p>
            </div>

            <div>
              <img src="/img/skills/csharp.png" alt="net-framwork">
              <p>.NET Framework/Core (C#)</p>
            </div>

            <div>
              <img src="/img/skills/sqlserver.png" alt="sqlserver">
              <p>SQL Server</p>
            </div>

            <div>
              <img src="/img/skills/hypertext.png" alt="html">
              <p>HTML</p>
            </div>

            <div>
              <img src="/img/skills/css.png" alt="css">
              <p>CSS</p>
            </div>

          </div>

        </div>
      </div>

      <div class="cont">

          <div class="body">
            <p>
              Informaticist since 2013, I've been dedicated to learning and preparing myself for working in technology since I was 15. 
              Within informatics, my specialty is programming, especially web programming, but this does not limit my abilities, also I 
              can participate (and have participated) in any stage of the software lifecycle, whether it's gathering the application's 
              requirements or deploying the final application.
            </p>

            <p>
              As a programmer, I can perform many roles, whether it's making web pages mockups using HTML and CSS or writing javascript 
              that will be run on a web browser, all this without any problem, but my true strength is the creation of web services (REST 
              APIs or Web APIs - based on the REST architecture) using javascript (NodeJS) as my principal programming language, which I 
              have more than 2 years of working. Also, I have more than 1 year of learning and working with the .NET (C# ASP.NET) ecosystem.
            </p>

<!--            <p>
              Informático desde el año 2013, me he dedicado a aprender y prepararme para trabajar en tecnología 
              desde que tenía 15 años. Dentro de la informática, mi especialidad es la programación, en especial la programación web, pero esto 
              no limita mis habilidades, también puedo participar (y he participado) en cualquier etapa del ciclo de vida 
              de una aplicación, ya sea en los levantamientos previos al desarrollo o en el despliegue de la aplicación final.
            </p>

            <p>
              Como programador también puedo desempeñar varios roles, ya sea realizando maquetas de páginas web usando HTML 
              y CSS o escribiendo scripts de JavaScript que serán ejecutados en un navegador web, todo eso sin problemas, pero 
              mi verdadero fuerte es la creación de servicios web (REST APIs o Web APIs) usando como lenguaje principal JavaScript 
              (NodeJS), con el que llevo más de 2 años de trabajo, y también C# .Net, con el que llevo más de 1 año aprendiendo y trabajando.
            </p>

             <p>
              I know how important is what I do and I take it so seriosly, because of that I'm looking for working places where they know and value 
              what I do, where I feel as part of the team and I not only could reach my limits, but also I could keep overconming myselft, all this 
              because I know that I still have a long path to walk.
            </p> -->
          </div>

          <div class="cvOptions">

            <div class="download" ref="cvDownload">
              <div @click="showCVOptions()">
                <i class="icofont-cloud-download"></i>
                <p>Download my CV</p>
              </div>
            </div>

            <div class="options" ref="cvOptions">

              <div @click="openCV_('/docs/cv/nethanzels_cv.pdf')">
                <i class="icofont-file-pdf"></i>
                <p>English document</p>
              </div>

              <div @click="openCV_('/docs/cv/nethanzels_cv_sp.pdf')">
                <i class="icofont-file-pdf"></i>
                <p>Documento en español</p>
              </div>

            </div>
          </div>

          <div class="recentPrj">
            <h2>Recent projects:</h2>
            <div class="prjView">
              <div class="slideView" ref="slideCnt">

                <div class="spinerParent" v-if="loading">
                  <img src="../assets/spin.png" alt="spinner" :style="{ height: '30px', width: '30px' }" />
                </div>

                <fetchError :style="{display:fetchErr?'flex':'none', margin: 'auto'}" :Exception="fetchErr" />

                <ProjectSuperLite v-for="(project, i) in recentProjects" :key="i" :projectData="project" :tools="tools" :class="`prj prj-${i}`" :style="{ display: 'none' }" />

              </div>
              <div class="slider" ref="positions" v-if="recentProjects">
                <span v-for="i in recentProjects.length" :key="i" :class="`sp-${i-1}`" @click="slideJumpTo(i-1)"></span>
              </div>

            </div>
          </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  import router from "../router/index.js";
  import queryPalette from "../mixins/themeColor.js";
  import ProjectSuperLite from "./Small/ProjectSuperLite.vue";
  import Request from "../mixins/axiosRequest";
  import fetchError from "./Small/fetchError.vue";

  export default {
    mounted() {
      window.addEventListener('load',  () => {
        document.querySelector("#ahImg").style.opacity = 1;
        document.querySelector("#ahImg").style.transform = "scale(1)";
      });

      router.afterEach((to) => {
        if(to.name == "Home") {
          setTimeout(() => {
            document.querySelector("#ahImg").style.opacity = 1;
            document.querySelector("#ahImg").style.transform = "scale(1)";
          }, 800);
        }
      });

      queryPalette.generatePalette().then((Palette) => {
        this.$refs.meshMe.style.backgroundImage += `radial-gradient(at 90% 15%, ${Palette[1][Math.floor(Palette.length / 2)]}9f 0, transparent 30%)`;
        this.$refs.meshMe.style.backgroundImage += `,radial-gradient(at 15% 90%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 40%)`;
      });

      this.getSkills();
    },
    beforeDestroy() {
      clearInterval(this.slideInterval);
    },
    components: {
      ProjectSuperLite,
      fetchError
    },
    data() {
      return {
        loading: true,
        recentProjects: null,
        tools: null,
        fetchErr: null,
        slidePos: 0,
        slideInterval: null
      }
    },
    methods: {
      async getProjects() {
        let data = await Request.axiosGet(`/api/projects/1`, this.client);
        if(data.status) {
          this.recentProjects = data.data.content;
          setTimeout(() => this.initSlide(), 500);
        } else {
          this.fetchErr = data.data;
        }
        this.loading = false;
      },

      async getSkills() {
        let data = await Request.axiosGet("/api/skills", this.client);
        if(data.status) {
          this.tools = data.data[0].technical;
          this.getProjects();
        } else {
          this.loading = false;
          this.fetchErr = data.data;
        }
      },

      initSlide() {
        if(!this.recentProjects.length) return;

        let sliderCont = this.$refs.slideCnt;
        let positionCont = this.$refs.positions;

        let prjCollection = sliderCont.getElementsByClassName('prj');
        
        for(let projectDiv of prjCollection) {
          projectDiv.style.display = 'none';
        }

        sliderCont.getElementsByClassName('prj-0')[0].style.display = 'flex';
        positionCont.getElementsByClassName(`sp-0`)[0].classList.add("select");

        this.slideInterval = setInterval(() => this.slideStep(+1, "animteRightToLeft"), 10000);
      },

      slideStep(step, animation) {
        if(!this.recentProjects.length) return;

        let max = this.recentProjects.length - 1;
        let nextStep = this.slidePos + (step);

        let beforeStep = this.slidePos;
        this.slidePos = nextStep;

        if(nextStep < 0 || nextStep > max) {
          this.slidePos = 0;
          nextStep = 0;
          beforeStep = max;
        };

        let sliderCont = this.$refs.slideCnt;
        let positionCont = this.$refs.positions;
      

        sliderCont.getElementsByClassName(`prj-${beforeStep}`)[0].style.display = "none";
        positionCont.getElementsByClassName(`sp-${beforeStep}`)[0].classList.remove("select");

        sliderCont.getElementsByClassName(`prj-${nextStep}`)[0].classList.add(animation);
        sliderCont.getElementsByClassName(`prj-${nextStep}`)[0].style.display = "flex";
        positionCont.getElementsByClassName(`sp-${nextStep}`)[0].classList.add("select");

        setTimeout(() => {
          sliderCont.getElementsByClassName(`prj-${nextStep}`)[0].classList.remove(animation)
        }, 410)

      },

      slideJumpTo(index) {
        if(index == this.slidePos) return;
        let jump = index - this.slidePos;
        let animation = jump > 0 ? "animteRightToLeft" : "animteLeftToRight";
        this.slideStep(jump, animation);

        clearInterval(this.slideInterval);
        this.slideInterval = setInterval(() => this.slideStep(+1, "animteRightToLeft"), 10000);
      },

      showCVOptions() {
        this.$refs.cvDownload.style.display = "none";
        this.$refs.cvOptions.style.display = "flex";
        setTimeout(() => {
          this.$refs.cvDownload.style.display = "flex";
          this.$refs.cvOptions.style.display = "none";
        }, 15000);
      },

      openCV_(url) {
        window.open(url, '_blank');
      }
    }
  }
</script>

<style scoped lang="scss">

@media (prefers-color-scheme: dark) {
  .profileCard {
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0px 0px 5px #000000ab;

    .img {
      grid-area: img;
      background:rgba(255, 255, 255, 0.4);

      .head {
        p, h1 {
          color: #000;
        }
      }
    }

    .cont {
      .body {
        p {
          color: #fff;
        }
      }
      .recentPrj {
        color: #fff;
        .select {
          background-color: #fff !important;
        }
      }

      .cvOptions {
        color: rgb(0, 0, 0);

        p {
          color: rgb(0, 0, 0);
        }

        .download {
          div {
            background-color: #ffffffab;
          }
        }
        .options {
          div {
            background-color: #ffffffab;
          }
        }
      }
    }
  }

  #cover:after {
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(0, 0, 0, 1) 90%
    );
  }

  #pTop {
    color: #000;
  }
  #pTop::after {
    border-bottom: 4px solid rgba(170, 170, 170, 0.5);
  }

  p {
    color: #fff;
  }

}

@media (prefers-color-scheme: light) {
  .profileCard {
    grid-template-columns: 40% 60%;
    background: rgba(0, 0, 0, 0.1);
    box-shadow: 0px 0px 5px #7e7e7eab;

    .img {
      grid-area: img;
      background:rgba(0, 0, 0, 0.4);

      .head {
        p, h1 {
          color: #000;
        }
      }
    }

    .cont {
      .body {
        p {
          color: #000;
        }
      }

      .recentPrj {
        color: #000;
        .select {
          background-color: #000 !important;
        }
      }

      .cvOptions {
        color: rgb(255, 255, 255);

        p {
          color: rgb(255, 255, 255);
        }

        .download {
          div {
            background-color: #000000ab;
          }
        }
        .options {
          div {
            background-color: #000000ab;
          }
        }
      }
    }
  }

  #cover:after {
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgb(255, 255, 255) 90%
    );
  }

  #pTop {
    color: #fff;
  }
  #pTop::after {
    border-bottom: 4px solid rgba(70, 70, 70, 0.5);
  }

  p {
    color: #000;
  }

  .spinerParent img {
    filter: invert(1);
  }

}

.profileCard {
  display: grid;
  grid-template-columns: 2;
  grid-template-rows: 2;
  grid-template-areas: 'img cont'
                       'img cont';

  grid-template-columns: 40% 60%;
  height: auto;
  margin: auto;
  max-width: 1200px;
  overflow: hidden;
  z-index: 1;
  -webkit-backdrop-filter: blur(6.2px);
  backdrop-filter: blur(6.2px);

  position: relative;
  top: 25px;

  .img {
    grid-area: img;
    padding: 0 0 5px 0;
  }

  .cont {
    grid-area: cont;
    padding: 10px 25px 5px 25px;
    display: flex;
    flex-direction: column;
    .body {
      padding: 5px 20px;
      p {
        text-align: justify;
        margin: 10px 0;
        font-weight: 500;
        font-size: 15px;
        line-height: 22px;
      }
    }

    .recentPrj {
      height: 100%;
      margin-top: 10px;
      transition: .4s;
      overflow: hidden;
      .prjView {
        //background-color: #fff;
        height: 100%;
        .slideView {
          height: auto;
          margin: 10px 0 0 0;
          display: flex;
          min-height: 75%;
        }
        .slider {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 15px;
          padding: 7px;
          span {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin: 0 6px;
            transition: .4s;
            cursor: pointer;
            background-color: #949494ab;
          }
          .select {
            width: 13px;
            height: 13px;
          }
        }
      }
    }

    .cvOptions {
      min-height: 35px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      margin: 0 0 5px 0;
      .download {
        display: flex;
        width: 100%;

        p {
          font-size: 14px;
          cursor: pointer;
          margin-top: -2px;
        }

        i {
          font-size: 27px;
          margin: 0 8px 0 0;
        }

        div {
          display: flex;
          align-items: center;
          margin: 0 auto;
          padding: 5px 9px 1px 9px;
          border-radius: 3px;
          cursor: pointer;

          &:hover {
            filter: invert(.75);
          }
        }

      }
      .options {
        display: none;
        width: 70%;
        
        p {
          font-size: 14.5px;
          cursor: pointer;
        }

        i {
          font-size: 23px;
          margin: 0 6px 0 0;
        }

        div {
          display: flex;
          align-items: center;
          margin: 0 auto;
          padding: 6px 9px 6px 9px;
          border-radius: 3px;
          cursor: pointer;
          &:hover {
            filter: invert(.75);
          }
        }
      }
    }
  }
}

.container {
  width: 100%;
  height: auto;
  min-height: calc(100vh - 55px);
  display: flex;
  flex-direction: column;
}

#cover {
  width: 100%;
  max-width: 1920px;
  top: 0;
  left: 0;
  height: 35vh;
  max-height: 415px;
  min-height: 415px;
  /* margin-bottom: 115px; */
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  margin: 0 auto 0 auto;
  position: absolute;
  z-index: 0;
  transition: .4s;
}

#cover img {
  object-fit: cover;
  width: 100%;
  height: 200%;
  opacity: 0;
  transform: scale(2.5);
  transition: all 4.5s ease;
}

#cover:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  pointer-events: none;
  width: 100%;
  height: 415px;
  max-height: 415px;
  min-height: 415px;
  overflow: hidden;
}

#photo {
  border-radius: 50%; 
  object-fit: scale-down;
  background-color: #fff;
  width: 340px;
  height: 340px; 
  transition: 0.6s;
  margin-top: 15px;
}

h1 {
  font-size: 42px;
  color: #fff;
  margin: 0;
  text-align: center;
  padding-bottom: 10px;
}

h1::after {
  content: "";
  display: block;
  margin: 0 auto;
  width: 250px;
  border-bottom: 4px solid rgba(70, 70, 70, 0.5);
  margin-top: 3px;
}

p {
  margin: 2px 0;
  transition: all 0.5s ease-in-out;
  text-align: center;
  font-size: 18px;
}

.mainskill {
  font-size: 20px;
  font-weight: bold;
  transition: .4s;
}

.coreTech {
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  pointer-events: none;
  user-select: none;
  div {
    display: flex;
    align-items: center;
    margin: 3px 5px;
    padding: 3px 8px;
    border: 1px solid rgba(0, 0, 0, 0.5);
    background-color: #ffffffab;
    img {
      height: 25px;
      margin: 0 8px 0 0;
    }
    p {
      font-size: 13px;
    }
  }
}

.spinerParen {
  margin: auto 0;
}

@media screen and (max-width: 1000px) {
  .profileCard {
    grid-template-areas: 'img img'
                         'cont cont';
    grid-template-columns: 50% 50%;
    margin: auto;
    max-width: unset;
    max-height: unset;
    .img {
      padding: 0 35px 25px 35px;
    }
    .cont {
      .recentPrj {
        .prjView {
          margin: 10px 0;
          .slideView {
            margin: 10px 0 0 0;
          }
        }
      }
    }
  }

  .container {
    width: 90vw;
    height: auto;
    margin: 25vh 0px 0 0px;
  }
}

@media screen and (max-width: 520px) {

  .profileCard {
    .img {
      .head {
        h1 {
          font-size: 40px;
        }
      }
    }
  }
}

@media screen and (max-width: 495px) {
  .profileCard {
    .img {
      .head {
        h1 {
          font-size: 36px;
        }
      }
    }
  }
}

@media screen and (max-width: 450px) {
  .container {
    width: 98%;
  }

  #pTop {
    font-weight: bold;
    margin: 0;
    text-align: center;
  }

  #pTop::after {
    width: 250px;
  }
  p {
    font-size: 15px;
  }

  #photo {
    width: 300px;
    height: 300px; 
  }

  .profileCard {
    .img {
      padding-left: 5px;
      padding-right: 5px;

      .head {
        h1 {
          font-size: 32px;
        }
        .mainskill {
          font-size: 18px;
        }
      }
    }
    .cont {
      padding: 10px 5px 5px 5px;
      .body {
        padding: 5px 15px;
      }

      .recentPrj {
        height: 100%;
        .prjView {
          .slideView {
            height: auto;
          }
          .slider {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 15px;
            padding: 7px;
            span {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              margin: 0 6px;
              transition: .4s;
              cursor: pointer;
              background-color: #949494ab;
            }
            .select {
              width: 13px;
              height: 13px;
            }
          }
        }
      }

      .cvOptions {
        .options {
          display: none;
          width: 100%;
          div {
            margin: 0 10px;
            width: 50%;
          }
        }
      }
    }
  }

  .coreTech {
    div {
      margin: 3px 5px;
      padding: 3px 6px;
      img {
        height: 23px;
      }
      p {
        font-size: 11px;
      }
    }
  }
}

@media screen and (max-width: 411px) {
  p {
    font-size: 14px;
  }
}

@media screen and (max-width: 388px) {
  p {
    font-size: 13px;
  }
}

@media screen and (max-width: 367px) {
  p {
    font-size: 12px;
  }
}

@media screen and (max-width: 351px) {
  p {
    font-size: 13px;
  }
}

  .animteRightToLeft {
    animation-name: moveRightToLeft;
    animation-duration: .4s;
  }

  .animteLeftToRight {
    animation-name: moveLeftToRight;
    animation-duration: .4s;
  }

  @keyframes moveRightToLeft {
    0% {
      transform: translateX(150%);
      opacity: 0;
    }
    100% {
      transform: translateX(0%);
      opacity: 1;
    }
  }

  @keyframes moveLeftToRight {
    0% {
      transform: translateX(-150%);
      opacity: 0;
    }
    100% {
      transform: translateX(0%);
      opacity: 1;
    }
  }
</style>
